import React from "react"
import ReactDOM from "react-dom"
import {BrowserRouter as Router} from "react-router-dom"
import App from "./App"
import {ContextProvider} from "./context/MyContext"

ReactDOM.render(
    <ContextProvider>
    <Router basename="/e-commerce">
        <App />
    </Router>
    </ContextProvider>, 
    document.getElementById("root")
)
